import React, { useEffect, useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import { Auth } from '../../../index'
import "./sign-up.css"
import "../auth.css"

const SignUp = ( {setSignedIn} ) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [error, setError] = useState("")

    const history = useHistory();

    useEffect(() => {
        Auth.onAuthStateChanged(user => {
            if (user) history.push("/home")
        })
    })

    const handleSignUp = () => {
        setError("");
        if (checkSignUpInfo()) {
            Auth.createUserWithEmailAndPassword(email, password)
            .then((res) => {
                setSignedIn(true)
                sessionStorage.setItem("signedIn", true)
            })
            .catch(error => {
                var errorMessage = error.message;
                setError(errorMessage)
            })
        }
    }

    const checkSignUpInfo = () => {
        let uwEmailRegex = /uw.edu/;
        if (!uwEmailRegex.test(email)) {
            setError("Please try again with your UW email. Our platform is here for UW students and researchers only.");
            return false
        }

        if (password !== passwordConfirm) {
            setError("Error: Passwords need to match");
            return false
        }
        return true
    }

    return (
        <div id='outer-wrapperr'>
        <div id='outer-container'>
            <div id='form-container'>
                <h1 style={{
                            'height': '2em',
                            'top': '3.4em',
                            'left': '11em',
                            'color': 'rgba(0, 0, 0, 0.75)',
                            'font-family': 'Open Sans',
                            'font-style': 'normal',
                            'font-weight': 'bold',
                            'font-size': '2.4em',
                            'margin-bottom': '0',
                            'text-align': 'center',
                            'padding-bottom': '0'
                            }}
                >Sign up</h1>
                <h1 style={{
                            'height': '4em',
                            'color': '#625FA1',
                            'font-family': 'Open Sans',
                            'font-style': 'italic',
                            'font-weight': 'bold',
                            'font-size': '1.2em',
                            'margin-top': '0',
                            'text-align': 'center',
                            'padding-top':'0',
                            'margin-bottom':'0em',
                            }}
                >with your UW email</h1>
                <p style={{
                        'text-align': 'left',
                        'padding-left':'4.3em',
                        'margin': '0.05em',
                        'font-family': 'Open Sans',
                        'font-style': 'normal',
                        'font-weight': '400'
                    }}>UW Email</p>
                <form id="sign-up">
                    {/* email */}
                    <div className="form-group">
                    <label htmlFor="email"></label>

                    <input className="form-control"
                        style = {{
                            'width': '75%',
                            'height': '2.2em',
                            }}
                        id="email"
                        type="email"
                        name="email"
                        placeholder='.......@uw.edu'
                        onChange={(event) => {
                            setEmail(event.target.value)
                        }}
                        />
                    </div>
                    <p style={{
                        'text-align': 'left',
                        'padding-left':'4.3em',
                        'margin': '0.05em',
                        'font-family': 'Open Sans',
                        'font-style': 'normal',
                        'font-weight': '400'
                    }}>Password</p>
                    {/* password */}
                    <div className="form-group">
                    <label htmlFor="password"></label>
                    <input className="form-control"
                        style = {{
                            'width': '75%',
                            'height': '2.2em',
                            }}
                        id="password"
                        type="password"
                        name="password"
                        placeholder='6+ characters'
                        onChange={(event) => {
                            setPassword(event.target.value)
                        }}
                        />
                    </div>
                    <p style={{
                        'text-align': 'left',
                        'padding-left':'4.3em',
                        'margin': '0.05em',
                        'font-family': 'Open Sans',
                        'font-style': 'normal',
                        'font-weight': '400'
                    }}>Confirm password</p>
                    {/* confirm password */}
                    <div className="form-group">
                    <label htmlFor="password"></label>
                    <input className="form-control"
                        style = {{
                            'width': '75%',
                            'height': '2.2em',
                            }}
                        id="password"
                        type="password"
                        name="password"
                        placeholder="Type again"
                        onChange={(event) => {
                            setPasswordConfirm(event.target.value)
                        }}
                        />
                    </div>

                    {/* buttons */}
                    <div id="button-container">
                        <button
                            className="btn btn-primary mr-2"
                            style = {{
                                'width': '50%',
                                'height': '2.2em',
                                'background': 'linear-gradient(92.83deg, #EFCAC6 0%, rgba(255, 255, 255, 0) 100%), #7370BB',
                                'border-radius': '45px',
                                'color': '#FFFFFF',
                                'border': 'none',
                                'margin': '1em',
                                }}
                            onClick={(e) => {
                                e.preventDefault()
                                console.log("signing up...")
                                handleSignUp()
                            }}>
                            I'm in!
                        </button>

                        <Link to='/sign-in'style = {{
                            'margin':'0.3em'
                                }}>
                                Already have an account? Log in.
                        </Link>
                    </div>

                </form>

                <p>{error}</p>
            </div>

            <div id='right-rec-container'>
            <h1 style={{
                            'width': '392px',
                            'height': '130px',

                            'font-family': 'Open Sans',
                            'font-style': 'normal',
                            'font-weight': 'bold',
                            'font-size': '2.4em',
                            'line-height': '65px',
                            'display': 'flex',
                            'align-items': 'center',
                            'text-align': 'center',
                            'color': 'rgba(255, 255, 255, 1)',

                            }}

                            >
                    Get your survey
                    results faster.
                </h1>
                <text style={{
                            'width': '370px',
                            'height': '273px',

                            'font-family': 'Open Sans',
                            'font-style': 'normal',
                            'font-weight': 'normal',
                            'font-size': '18px',
                            'line-height': '50px',
                            'color': 'rgba(255, 255, 255, 1)',

                            }}>
                    • Exclusive for UW students and researchers

                    • Target your survey results to UW students

                    • No need to spam your friends and families
                </text>
            </div>
        </div>
        </div>
    );
}

export default SignUp;